// extracted by mini-css-extract-plugin
export var root = "sample-module--root--+TESD";
export var blogContainer = "sample-module--blogContainer--lLfdF";
export var excerpt = "sample-module--excerpt--U4Quv";
export var blogParagraph = "sample-module--blogParagraph--VOgUx";
export var imagesContainer = "sample-module--imagesContainer--8TYU0";
export var imageContainer = "sample-module--imageContainer--eOpwO";
export var blogSubHeader = "sample-module--blogSubHeader--49O-5";
export var content = "sample-module--content--7IsRR";